import React from 'react';
import { UserAvatar } from './UserAvatar';
import { cn } from '@/lib/utils';

export interface CreatorProfile {
  uid: string;
  email?: string | null;
  displayName?: string | null;
  photoURL?: string | null;
  avatarUrl?: string | null;
}

interface CreatorBadgeProps {
  creator?: CreatorProfile | null;
  fallbackName?: string;
  className?: string;
  nameClassName?: string;
  avatarClassName?: string;
}

export const CreatorBadge: React.FC<CreatorBadgeProps> = ({
  creator,
  fallbackName = 'Unknown',
  className,
  nameClassName,
  avatarClassName,
}) => {
  const displayName = creator?.displayName || creator?.email || fallbackName;
  const avatarUrl = creator?.avatarUrl || creator?.photoURL || null;

  return (
    <div className={cn('flex min-w-0 items-center gap-2', className)}>
      <UserAvatar
        src={avatarUrl}
        name={displayName}
        email={creator?.email}
        className={cn('h-7 w-7 shadow-sm', avatarClassName)}
        fallbackClassName="text-[10px]"
      />
      <span className={cn('truncate text-sm text-muted-foreground', nameClassName)}>
        {displayName}
      </span>
    </div>
  );
};
